module.exports = __webpack_public_path__ + "static/media/2-1.2a89fc96.png";